const list = {
  path: 'list',
  component: resolve => require(['../../../../../../../pages/admin/merchant/dispose/shopkeeper/list'], resolve),
  meta: {
    requireAuth: true
  }
}

export default list